import { render, staticRenderFns } from "./manage-consultation-commentaire.html?vue&type=template&id=474e126a&scoped=true&external"
import script from "./manage-consultation-commentaire.js?vue&type=script&lang=js&external"
export * from "./manage-consultation-commentaire.js?vue&type=script&lang=js&external"
import style0 from "./manage-consultation-commentaire.scss?vue&type=style&index=0&id=474e126a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e126a",
  null
  
)

export default component.exports